import React from 'react';
import { Label } from 'components/lib';
import Style from './checkbox.tailwind.js';

export function Checkbox(props){

  return (
    <div>
      <input
        type='checkbox'
        name={ props.name }
        id={ props.option.toString() }
        value={ props.option }
        className={ Style.input }
        checked={ props.checked ? 'checked' : '' }
        onChange={ e => props.callback(props.index, props.checked, props.option)}
        disabled={props.readonly}
      />

      <Label
        text={ props.option }
        required={ props.required }
        for={ props.option.toString() }
        className={ Style.label }
      />
    </div>
  );
}
